<lvr-heading>{{ 'workplace.edit.title' | transloco }}</lvr-heading>

<form class="form-container" [formGroup]="form" lvrAutoSave="workplace" [entityId]="draftId()" [autoLoad]="false">
	<section class="form-grid">
		<section>
			<!-- Name -->
			<lvr-field [label]="'base.field.name' | transloco | appendAsterisk">
				@let nameCtrl = form.controls.name;
				<mat-form-field lvrInput [lvrError]="hasError(nameCtrl, 'pattern', 'required')">
					<input
						matInput
						formControlName="name"
						[placeholder]="'base.field.workplace_placeholder' | transloco"
						[errorStateMatcher]="matcher"
					/>
					@if (hasError(nameCtrl, 'pattern')) {
						<mat-error>{{ 'base.form.error.branch_name_invalid' | transloco }}</mat-error>
					}
					@if (hasError(nameCtrl, 'required')) {
						<mat-error>{{ 'base.form.error.name_required' | transloco }}</mat-error>
					}
				</mat-form-field>
			</lvr-field>

			<!-- Remark field (address-related) -->
			@let remarkCtrl = form.get('addressRemark');
			<lvr-field [label]="'base.field.remark' | transloco">
				<mat-form-field lvrInput [lvrError]="hasError(remarkCtrl, 'maxlength')">
					<textarea
						matInput
						formControlName="addressRemark"
						[placeholder]="'base.field.remark_placeholder' | transloco"
						[errorStateMatcher]="matcher"
						[maxlength]="maxRemarkLength"
					></textarea>
					@if (hasError(remarkCtrl, 'maxlength')) {
						<mat-error>{{ 'base.form.error.max_length_exceeded' | transloco: { max: maxRemarkLength } }}</mat-error>
					}
					<mat-hint>{{
						'base.field.remark_hint' | transloco: { actual: remarkCtrl?.value?.length || 0, max: maxRemarkLength }
					}}</mat-hint>
				</mat-form-field>
			</lvr-field>

			<!--Branche field-->
			@if (user().roles?.id === eaaRole) {
				<lvr-branch-field formControlName="industryName" class="branch-field"></lvr-branch-field>
			}
		</section>
		<div class="address-remark-group">
			<lvr-field>
				<!-- Address Field -->
				<lvr-address-completion
					[showAsterisk]="false"
					class="address-completion"
					formControlName="address"
				></lvr-address-completion>
			</lvr-field>
		</div>
	</section>

	<!-- Contact Point Field -->
	@for (item of contactPoints; track item; let index = $index) {
		<section class="form-grid">
			<h3 lvrPadding class="additional-communication-heading" [padVertical]="0" [padHorizontal]="8">
				<span>{{ 'base.field.contact_point.title' | transloco }}</span>
				<button matIconButton class="btn btn-tertiary" (click)="removeContactPoint(index)">
					<mat-icon class="material-symbols-outlined" aria-hidden="true">delete</mat-icon>
				</button>
			</h3>
			<lvr-contact-point
				[contactPointCategories]="contactPointCategories()"
				class="address-completion"
				[initValue]="contactPoints[$index]"
				(values)="updateValues($event, $index)"
			></lvr-contact-point>
		</section>
	}
	<!-- Add additional button -->
	@if (contactPoints.length < 5) {
		<section class="form-grid">
			<lvr-button
				variant="primary"
				[label]="'institution.create.add_additional' | transloco"
				[ariaLabel]="'institution.create.additional_communication' | transloco"
				[type]="'button'"
				(clicked)="addContactPoint()"
				icon="add"
			></lvr-button>
		</section>
	}

	<p class="required-hint">{{ 'base.form.required' | transloco }}</p>

	<lvr-default-actions
		[disableSave]="form.invalid || !canEditInstitutionsPermission()"
		[showLoading]="saving()"
		(save)="update()"
		(cancelSave)="cancel()"
	>
		<lvr-restore-actions entityType="workplace" [entityId]="draftId()"></lvr-restore-actions>
	</lvr-default-actions>
</form>
